import styled from 'styled-components'
import variables from '../../styles/variables'

export const Container = styled.div`
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 20px 0;
  animation: fadeIn 0.6s ease-in-out 0.4s;
  animation-fill-mode: forwards;
  opacity: 0;
  
  @media ${variables.media.sm} {
    margin: 30px 0;
    gap: 12px;
  }
`

export const Pill = styled.div`
  background: #272344;
  border-radius: 4px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0.9;
  
  @media ${variables.media.sm} {
    padding: 6px 16px;
    gap: 8px;
  }
`

export const Value = styled.span`
  font-family: ${variables.fonts.header};
  font-weight: 600;
  font-size: 12px;
  color: ${variables.colors.turquoiseAccent};
  
  @media ${variables.media.sm} {
    font-size: 14px;
  }
`

export const Label = styled.span`
  font-family: ${variables.fonts.header};
  font-weight: 600;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  
  @media ${variables.media.sm} {
    font-size: 14px;
  }
`